import { render, staticRenderFns } from "./FormStandart.vue?vue&type=template&id=3f4b439e&scoped=true&"
import script from "./FormStandart.vue?vue&type=script&lang=js&"
export * from "./FormStandart.vue?vue&type=script&lang=js&"
import style0 from "./FormStandart.vue?vue&type=style&index=0&id=3f4b439e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4b439e",
  null
  
)

export default component.exports